import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/reports/historyMovement/filter'; // Importing Filter component
import Table from 'views/reports/historyMovement/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the history movement view.
 * @extends JetView
 */
export default class historyMovementView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100', '1000'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                            $$('datatable').scrollTo(100, 0); // Scroll to top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var table = $$('datatable'); // Reference to the data table
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // Calculate first record index
                            var last = first + size - 1; // Calculate last record index
                            if (value !== '') {
                                vthis.app.callEvent('export:filter', [
                                    { value: value, first: first, last: last }, // Trigger export event with parameters
                                ]);
                            }
                        },
                    },
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Historial de movimientos') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event to show filter popup
                                        $$('filterPopup').show();
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Including Filter component
                Table, // Including Table component
                toolbar, // Including toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Main view type
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left panel configuration
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export dropdown for small screens
                $$('pagerA').define('group', 1); // Group pager items
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen size
                $$('button-search').hide(); // Hide search button
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $$(document).height() - this.scrollTop() - this.height();
            };
        });
    }
}

// FILE DOCUMENTED
